import { render, staticRenderFns } from "./personal-manage.vue?vue&type=template&id=4d393704&scoped=true&"
import script from "./personal-manage.vue?vue&type=script&lang=js&"
export * from "./personal-manage.vue?vue&type=script&lang=js&"
import style0 from "./personal-manage.vue?vue&type=style&index=0&id=4d393704&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d393704",
  null
  
)

export default component.exports